import { gql } from '__generated__';

export default gql(`
  query GetEvent($id: ID!, $invitationCode: String, $coupon: String) {
    practicalInfoTopics
    event(id: $id) {
      id
      project {
        id
        organisation_name
        organisation_email
        logo {
          id
          url
        }
        organisation_address
        organisation_zip_code
        organisation_city
        organisation_country
        shift_vat
        currency
        locale
        timezone
        privacy_statement
        google_analytics
        facebook_pixel
        genders
      }
      locale
      brand_color
      title
      registration_opens_at
      description
      checkout_description
      usp_facts {
        id
        title
      }
      whats_included_facts {
        id
        title
        description
      }
      practical_info_facts {
        id
        title
        description
      }
      resale_description
      email
      website_url
      location {
        id
        title
        description
      }
      logo {
        id
        url
      }
      photos {
        id
        file {
          id
          url
        }
      }
      terms {
        id
        url
      }
      trend_score
      related_events {
        id
        title
        start_date
        end_date
        brand_color
        location {
          id
          description
          city
        }
        header {
          id
          file {
            id
            url
          }
        }
        ticket_categories {
          id
          sport_type
        }
        checkout_url
      }
      show_ticket_availabilities
      show_ticket_availabilities_under
      payment_methods
      require_company_for_bank_transfer
      terms_url
      terms_text
      confirmation_text
      resale_confirmation_text
      participant_attributes
      start_date
      end_date
      age_threshold_date
      enable_fundraising
      require_fundraising
      fundraising_mode
      supporta_url
      allow_other_charity
      charities {
        id
        title
        logo_url
        description
      }
      random_charities {
        id
        title
        logo_url
      }
      charities_count
      fundraising_charities_count
      fundraising_campaigns_count
      funds_raised
      invitation_code(invitation_code: $invitationCode) {
        id
        availability
        value
        invitation {
          id
          description
          team {
            id
            title
          }
        }
      }
      ticket_categories(invitation_code: $invitationCode, coupon: $coupon) {
        id
        title
        start_date
        sport_type
        current_max_per_order
        formatted_distances
        tickets_for_sale {
          id
          title
          description
          assignment_type
          image {
            id
            url
          }
          vat_percentage
          min_per_order
          current_max_per_order
          published_availability
          is_sold_out
          allow_resale
          cached_registrations_for_sale_count
          current_discount {
            ...GetEvent_DiscountFields
          }
          accept_down_payments
          promotions_for_sale {
            ...GetEvent_PromotionFields
          }
          participant_attributes
          upcoming_time_slots {
            id
            start_date
            start_time
            title
            multi_date
            is_sold_out
            current_max_per_order
            published_availability
          }
          units
          business
          preregistration
          allow_individuals
          allow_create_team
          allow_join_team
          team_type {
            id
          }
          allow_companies
          restrictions {
            id
            gender
            min_age
            max_age
          }
          charity {
            id
            title
            logo_url
            description
          }
        }
      }
      products_for_sale {
        id
        title
        description
        image {
          id
          url
        }
        vat_percentage
        min_per_order
        current_max_per_order
        is_sold_out
        current_discount {
          ...GetEvent_DiscountFields
        }
        type
        minimum_donation_amount
        accept_down_payments
        stand_alone
        promotions_for_sale {
          ...GetEvent_PromotionFields
          required_promotion_ids
        }
        active_product_variants {
          id
          title
          is_sold_out
          current_max_per_order
        }
        min_per_ticket
        max_per_ticket
        min_per_order
        max_per_order
        products {
          id
        }
      }
      enabled_participant_fields(invitation_code: $invitationCode) {
        id
        title
        description
        scope
        type
        enabled_choices {
          id
          title
          position
          enabled
        }
        required
        required_promotions {
          id
        }
        required_participant_attributes
        config
        has_external_validation
      }
      team_types {
        id
        title
        join_policy
      }
      mail_permissions {
        id
        title
        label
        soft_opt_in
      }
      accept_down_payments
      down_payment_deadline
      down_payment_percentage
      has_invitation_codes
      checkout_url
      active
      enable_public_resale
      public_resale_start_date
      public_resale_end_date
      enable_private_resale
      private_resale_start_date
      private_resale_end_date
      resale_url
      enable_waitlist
      enable_interest_list
      interest_list {
        id
        title
        label
      }
      cached_registrations_for_sale_count
    }
  }

  fragment GetEvent_PromotionFields on Promotion {
    id
    title
    amount
    current_amount
    current_max_per_order
    standard
    is_sold_out
    end_date
  }

  fragment GetEvent_DiscountFields on Discount {
    id
    title
    strategy
    type
    levels {
      id
      end_date
      quantity
      value
    }
  }
`);
